import { DateUtils } from '@web_opxp/features';
import { ExitCode, WorkoutUnityResult } from 'web_unity_engine';
import type { IStatState, ITutorialState } from './types';

// possible statuses
export enum SupportStatusEnum {
  TECH_NOT_SUPPORTED = 'TECH_NOT_SUPPORTED',
  TECH_BLOCKED = 'TECH_BLOCKED',
  TECH_READY = 'TECH_READY',
}

export const unitySupportStatus = () => {
  return new Promise<string>((resolve) => {
    try {
      // check for webGL and AudioAPI present
      if (!window.WebGLRenderingContext) {
        resolve(SupportStatusEnum.TECH_NOT_SUPPORTED);
      }
      // try to initialize context
      const canvas = document.createElement('canvas');
      let gl;
      // standart webgl is implemented
      gl = canvas.getContext('webgl');
      if (gl === null) {
        // experimental feature in old Safari
        gl = canvas.getContext('experimental-webgl');
      }
      if (gl) {
        resolve(SupportStatusEnum.TECH_READY);
      } else {
        resolve(SupportStatusEnum.TECH_BLOCKED);
      }
      document.removeChild(canvas);
    } catch {
      resolve(SupportStatusEnum.TECH_BLOCKED);
    }
  });
};

export const isWorkoutCancelled = (unityResult: WorkoutUnityResult) => unityResult.exitCode === ExitCode.Canceled;

const UnityUtils = {
  isWorkoutCancelled,
  unitySupportStatus,
  SupportStatusEnum,
};

export default UnityUtils;

const CategoryGroupIdRegex = /\{CategoryGroupId\}/;

export const testForCategoryGroupIdPlaceholder = (statId: string) => {
  return CategoryGroupIdRegex.test(statId);
};

export const replaceCategoryGroupIdPlaceholder = (statId: string, value?: string | number) => {
  return statId.replace(CategoryGroupIdRegex, `${value}`);
};

export function parseTutorialStateStat(statValue?: string, lastEdit = 0): ITutorialState | undefined {
  if (!statValue) {
    return undefined;
  }
  const payload = { valueInt: 0, valueTxt: statValue };
  return {
    lastEdit: lastEdit > 0 ? lastEdit : DateUtils.getUnixTimestamp(),
    payload,
  };
}

export function parseReadStateStat(statValue?: string): IStatState | undefined {
  if (!statValue) {
    return undefined;
  }
  const payload = { valueInt: 0, valueTxt: statValue };
  return {
    payload,
  };
}

export function parseSolutionConfirmStat(statValue?: string): IStatState | undefined {
  return parseReadStateStat(statValue);
}
